export enum DefaultDates {
  None = 1,
  PickDates = 2,
  CurrentDate = 3,
  BeforeCurrentDate = 4,
  AfterCurrentDate = 5,
}

export const DefaultDateLabels = {
  [DefaultDates.None]: 'None',
  [DefaultDates.PickDates]: 'Pick Dates/Times',
  [DefaultDates.CurrentDate]: 'Current Date',
  [DefaultDates.BeforeCurrentDate]: 'Before Current Date',
  [DefaultDates.AfterCurrentDate]: 'After Current Date',
};